import { render, staticRenderFns } from "./IconCreate.vue?vue&type=template&id=fc04b146&functional=true"
import script from "./IconCreate.vue?vue&type=script&lang=js"
export * from "./IconCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports